import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";
import { useState } from "react";

const NavButtonz = ({
  icon,
  hover,
  className,
  to,
  onClick,
  label,
  target,
  rel,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={to || "#"}
      className={`nav-button ${className || ""}`}
      target={target}
      rel={rel}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      aria-label={label}
    >
      <span>
        <SvgIcn name={isHovered && hover ? hover : icon} className="icon"/>
      </span>
      {label}

    </a>
  );
};

export default NavButtonz;
